define.alias("shared/helpers/format-number-with-suffix", "calendar/helpers/format-number-with-suffix");